// src/slices/moduleManagement/thunk.ts
// Async thunks cho Quản lý Module

import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  getModules,
  getModuleById,
  createModule as createModuleAPI,
  updateModule as updateModuleAPI,
  deleteModule as deleteModuleAPI,
} from 'helpers/fakebackend_helper';
import { CreateModuleDto, UpdateModuleDto } from 'pages/ModuleManagement/types';
import { createScreenText } from 'helpers/screenText';
const st = createScreenText('module_management_messages');

// Lấy danh sách modules — includeInactive=true để màn quản trị thấy cả module đã tắt
export const fetchModules = createAsyncThunk(
  'ModuleManagement/fetchModules',
  async (_: void, { rejectWithValue }) => {
    try {
      const response = await getModules(true as any);
      return response.data || response;
    } catch (error: any) {
      return rejectWithValue(error?.message || st('co_loi_xay_ra_khi_tai_message'));
    }
  }
);

export const fetchModuleDetail = createAsyncThunk(
  'ModuleManagement/fetchModuleDetail',
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await getModuleById(id);
      return response.data || response;
    } catch (error: any) {
      return rejectWithValue(error?.message || st('co_loi_xay_ra_khi_tai_message_2'));
    }
  }
);

export const createNewModule = createAsyncThunk(
  'ModuleManagement/createModule',
  async (module: CreateModuleDto, { rejectWithValue }) => {
    try {
      const moduleResponse = await createModuleAPI(module);
      const moduleId = (moduleResponse.data ?? moduleResponse) as number;
      return moduleId;
    } catch (error: any) {
      return rejectWithValue(error?.message || st('co_loi_xay_ra_khi_tao_message'));
    }
  }
);

export const updateExistingModule = createAsyncThunk(
  'ModuleManagement/updateModule',
  async (data: UpdateModuleDto, { rejectWithValue }) => {
    try {
      const response = await updateModuleAPI(data.id, data);
      return response.data || response;
    } catch (error: any) {
      return rejectWithValue(error?.message || st('co_loi_xay_ra_khi_cap_message'));
    }
  }
);

export const deleteModuleById = createAsyncThunk(
  'ModuleManagement/deleteModule',
  async (id: number, { rejectWithValue }) => {
    try {
      await deleteModuleAPI(id);
      return id;
    } catch (error: any) {
      return rejectWithValue(error?.message || st('co_loi_xay_ra_khi_xoa_message'));
    }
  }
);
